<template>
    <div class="bxTjzbhxr" v-if="kbxmlc">
      <div class="box noBtn">
        <div class="row">
          <div class="clear">
            <p class="cont-title lf">多轮报价</p>
          </div>
          <div class="row">
            <el-button type="primary" :disabled="publishState" @click="publishPrice">公布报价</el-button>
          </div>
        </div>
        <div class="main">
          <table-tem
            v-loading="loading"
            ref="table"
            :config="tableConfig"
            :key="tableConfig.key"
            :span-method="objectSpanMethod"
            :highlightCurrentRow="false"
            @changePage="tableChangePage"
            @changePages="changePages"
          >
          </table-tem>
        </div>
        <el-button
          v-if="role == 'Z'"
          :disabled="
            isNext ||
            djsTime != 0 ||
            ([undefined, null, ''].includes(csjg) && kbxm.zbxmkpfs == '10')
          "
          @click="bxNextBtn"
          type="primary lcNext"
          >下一步</el-button
        >
      </div>    
      <el-dialog
      title="公布报价"
      :visible.sync="publishPriceState"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="rules">
        <p>请确认是否公布历史报价</p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="publish">是</el-button>
        <el-button type="primary" @click="publishPriceState = false">否</el-button>
      </div>
    </el-dialog>
    </div>
    <div v-else class="loading">
      <p>页面正在加载中...</p>
      <div id="colorfulPulse">
        <span class="item-1"></span>
        <span class="item-2"></span>
        <span class="item-3"></span>
        <span class="item-4"></span>
        <span class="item-5"></span>
        <span class="item-6"></span>
        <span class="item-7"></span>
      </div>
    </div>
  </template>
  
  <script>
  import tableTem from "@/components/tableTem/index.vue";
  export default {
    components: {
      tableTem,
    },
    computed: {
      handleMinutes() {
        return (data) => {
          let minutes = Math.floor(data / 60);
          let remainingSeconds = data % 60;
          return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
            .toString()
            .padStart(2, "0")}`;
        };
      },
      role() {
        return localStorage.getItem("role") ? localStorage.getItem("role") : "T";
      },
      isNext() {
        return this.kbxmlc.zt == 2;
      },
    },
    data() {
      return {
        waitLoading: false,
        djlcId: "", //节点流程id
        kbxmlc: {},
        tableConfig: {
          head: [],
          data: [],
          total: 0,
          currentPage: 1,
          pageSize: 10,
          border: true,
          key: 1,
        },
        options: [
          {
            value: 1,
            label: "按投标单位自动推荐最低价",
          },
          {
            value: 2,
            label: "按条目自动推荐最低价",
          },
        ],
        tjzbhxr: null,
        tableData: [],
        number: [],
        dialogVisible: false,
        dialogFormVisible: false, //设置参数
        dscbDialogVisible: false, //电声唱标
        candidate: null,
        candidateOptions: [],
        tbdwmc: "",
        multipleSelection: [], // 表格选择
        dsForm: {
          volume: 1,
          rate: 1,
        },
        synth: "", //对象
        msg: "", //实例
        isStop: false, //是否暂停电声状态
        isStart: false,
        text: [], //电声内容
        csjg: "", // 是否已经设置过参数
        num: 0,
        form: {},
        formItem: [],
        kbxm: {},
        showRules: false,
        rules: "",
        cqgsValue: 0,
        time: null,
        djsTime: 0,
        dialogBjVisible: false,
        bjTime: "",
        loading: false,
        publishPriceState: false,
        publishState: false
      };
    },
    created() {
      this.djlcId = this.$route.query.djlcId;
      this.tjzbhxr = 1;
      this.$nextTick(() => {
        this.getData();
        this.checkPublishPrice();
      });
    },
    beforeDestroy() {
      clearInterval(this.time);
      this.time = null;
    },
    methods: {
      bjDialogClose() {
        this.dialogBjVisible = false;
      },
      publishPrice(){
        this.publishPriceState=true;
      },
      //公布报价
      async publish(){
        try{
          const res =await this.$api.publishPrice();
          if(res.data.success){
            this.$message.success("公布成功");
            this.publishPriceState = false;
            this.getData();
            this.checkPublishPrice();
          }else{
            this.$message.error(res.data.msg);
          }
        }catch(error){
          this.$message.error(error.data.msg);
        }
      },
      async checkPublishPrice(){
        try {
        let res = await this.$api.checkPublishPrice();
        console.log('res',res)
        if (res.data.success) {
          this.publishState = res.data.data
        } else {
          this.$message({ type: "error", message: res.message });
        }
      } catch (err) {
        console.log(err);
      }
      },
      async endBj() {
        let params = {
          num: this.kbxm.bjcs,
        };
        try {
          const res = await this.$api.endMultipleQuotes(params);
          if (res.data.success) {
            this.$message.success("提前结束成功");
            clearInterval(this.time);
            this.time = null;
            this.djsTime = 0;
            this.getData();
            let obj = {
              lx: "tbr",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
          } else {
            this.$message.error(res.data.msg);
          }
        } catch (error) {
          this.$message.error(error.data.msg);
        }
      },
      endQuotes() {
        this.$confirm(
          `确定提前结束第${this.kbxm.bjcs}轮报价？仅全部投标人都完成报价了方可提前结束本轮报价`,
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.endBj();
          })
          .catch((error) => {
            this.$message.error(error.data.msg);
          });
      },
      async submitBj() {
        let params = {
          num: this.kbxm.bjcs + 1,
          timeout: this.bjTime,
        };
        const res = await this.$api.openMultipleQuotes(params);
        if (res.data.success) {
          this.$message.success("开启成功");
          this.dialogBjVisible = false;
          this.getData();
          let obj = {
            lx: "tbr",
            data: {
              id: "",
            },
          };
          this.$emit("send", JSON.stringify(obj));
        } else {
          this.$message.error(res.data.message);
        }
      },
      setQuotes() {
        this.dialogBjVisible = true;
      },
      closeDialog() {
        this.dialogFormVisible = false;
        this.cqgsValue = 0;
      },
      searchData() {
        let obj = {
          tbdwmc: this.tbdwmc,
        };
        this.getData(obj);
      },  
    
      changeData(secondaryName, threeLevelName) {
        this.tableConfig.data = [];
        this.number = [];
        this.companyFlag = false;
        for (const v of this.tableData) {
          v[secondaryName].map((k, index) => {
            k[threeLevelName].map((p, index) => {
              k[p.bjcsId] = p.csznr;
            });
          });
        }
        for (const v of this.tableData) {
          v[secondaryName].map((k, index) => {
            let param = {
              ...v,
              qdmc: this.tjzbhxr == 1 ? k.qdmc : v.qdmc,
              qymc: this.tjzbhxr == 1 ? v.qymc : k.qymc,
              ...k,
            };
            this.tableConfig.data.push(param);
          });
        }
        for (let i = 0; i < this.tableData.length; i++) {
          this.number.push({
            qdmc: this.tableData[i].qdmc,
            num: this.tableData[i][secondaryName].length,
          });
        }
        let msgIndex = 0;
        let msgArr = [];
        for (let i = 0; i < this.number.length; i++) {
          let num = this.number[i].num;
          msgIndex += num;
          msgArr.push(msgIndex);
        }
        msgArr.pop();
        msgArr.unshift(0);
        for (let i = 0; i < this.number.length; i++) {
          let num = this.number[i].num;
          this.tableConfig.data[msgArr[i]].rowspan = num;
        }
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // 如果是前两列，就使用idIndex数据来进行合并
        if (this.tjzbhxr == 1) {
          if ([0, 1, 2].includes(columnIndex)) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        } else {
          if (columnIndex <= 2) {
            return {
              rowspan: row.rowspan,
              colspan: 1,
            };
          }
        }
      },
      getData(data) {  
        if (this.time != null) {
          clearInterval(this.time);
          this.time = null;
        }
        this.once();
        this.$refs.table.$refs.tableTem.clearSelection();
        this.candidate = null;
        let para = {
          djlcId: this.djlcId,
          currentPage: this.tableConfig.currentPage,
          type: this.tjzbhxr,
          pageSize: this.tableConfig.pageSize,
        };
        para = Object.assign(para, data);
        this.waitLoading = true;
        this.loading = true;
        this.$api
          .getCbList(para)
          .then((res) => {
            if (res.data.meta.success) {
              let cgTbbjCsList = res.data.data.cgTbbjCsList || [];
              cgTbbjCsList.map((item, index) => {
                this.tableConfig.head.splice(3 + index, 0, {
                  key: item.id,
                  title:
                    item.cszmc + (item.bjlxdw ? "(" + item.bjlxdw + ")" : ""),
                  align: "center",
                });
              });
              this.csjg = res.data.data.csList;
              this.tableData = res.data.data.tbdwList.list;
              this.tableConfig.total = res.data.data.tbdwList.total;
              this.kbxm = res.data.data.kbxm;
              // 多轮报价倒计时
              // let now = await this.$api.getGjsssj({});
              // console.log(now, "-----");
              if (this.kbxm.dcbjQrsj) {
                this.time = setInterval(async () => {
                  let dcbjQrsj = new Date(this.kbxm.dcbjQrsj).getTime();
                  let nowTime = await this.$api.getGjsssj({});
                  let now = new Date(nowTime.data.data.gjsssj).getTime();
                  this.djsTime = Math.ceil((dcbjQrsj - now) / 1000);
                  console.log(this.djsTime, this.kbxm.dcbjQrsj, "--------");
                  if (this.djsTime <= -1) {
                    // 前端时间戳和后端获取的时间戳有差1秒的情况
                    clearInterval(this.time);
                    this.time = null;
                    this.djsTime = 0;
                    this.getData();
                  }
                }, 1000);
              }
              this.kbxmlc = res.data.data.kbxmlc;
              this.tableConfig.key++;
              this.changeData("tbdwQdTbdwResultList", "tbdwCsTbdwResultList");
              if (!("speechSynthesis" in window)) {
                if (this.kbxmlc.zt != "2") {
                  this.$message({
                    type: "error",
                    message:
                      "对不起，您的浏览器不支持电声唱标，请更换急速模式或者谷歌浏览器",
                  });
                }
              } else {
                this.msg = null;
                this.synth = window.speechSynthesis;
                this.synth.speak(new SpeechSynthesisUtterance(""));
                this.init();
              }
            } else {
              this.$message({
                type: "error",
                message: res.data.meta.message,
              });
            }
            this.waitLoading = false;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      init() {
        this.msg = new SpeechSynthesisUtterance();
        let _this = this;
        this.msg.onend = function () {
          //唱完了
          if (_this.num == _this.text.length - 1) {
            _this.synth.cancel(_this.msg);
            _this.num = 0;
            _this.$refs.table.$refs.tableTem.setCurrentRow();
          } else {
            _this.num++;
            _this.handleSpeak();
          }
          _this.isStart = false;
        };
        this.msg.onstart = function () {
          _this.isStart = true;
        };
      },
      once() {
        this.tableConfig.head = [
          {
            type: "selection",
            width: 40,
          },
          {
            key: "xh",
            title: "序号",
            align: "center",
            width: 60,
          },
          {
            key: "qymc",
            title: "投标单位名称",
            align: "center",
          },
        ];
      },
      dialogShow() {
        console.log(this.$refs.table.checkList);
        const list = this.$refs.table.checkList;
        if (list.length == 1) {
          this.dialogVisible = true;
        } else {
          this.$message.warning("请勾选1家投标单位");
        }
      },
      async bxNextBtn() {
        let bool = false;
        let params = {
          num: this.kbxm.bjcs,
        };
        const res = await this.$api.checkMultipleQuotes(params);
        if (res.data.success) {
          bool = res.data.data;
        }
        if (bool) {
          this.$confirm(
            "当前项目多轮报价，存在最终报价未报价的单位，确定废除并进入符合性审查？",
            "温馨提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.nextCheck();
            })
            .catch(() => {});
        } else {
          this.nextCheck();
        }
      },
      nextCheck() {
        if (!this.csjg || this.csjg == "") {
          if (this.showGz) {
            this.$message.error("请设置参数！");
          } else {
            this.$confirm(
              "您还未设置参数，请确认该项目无参数需要设置！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                let para = {
                  flag: this.kbxmlc.ycdz,
                };
                this.waitLoading = true;
                this.$emit("nextBtn", para);
              })
              .catch(() => {});
          }
        } else if (this.isStart) {
          this.$confirm("请确认是否结束电声唱标，并进入下一步！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let para = {
                flag: this.kbxmlc.ycdz,
              };
              this.waitLoading = true;
              this.$emit("nextBtn", para);
            })
            .catch(() => {});
        } else {
          let para = {
            flag: this.kbxmlc.ycdz,
          };
          this.waitLoading = true;
          this.$emit("nextBtn", para);
        }
      },
      // 分页功能
      tableChangePage(e) {
        this.tableConfig.currentPage = e;
        this.getData();
      },
      changePages(e) {
        this.tableConfig.pageSize = e;
        this.getData();
      },
    },
  };
  </script>
  
  <style lang='scss' scoped>
  ::v-deep .el-form-item__content {
    display: flex;
  }
  .noBtn {
    display: flex;
    flex-direction: column;
  }
  .main {
    flex: 1;
    .main-top {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      .main-top-left {
        margin-bottom: 10px;
        label {
          margin-right: 20px;
        }
      }
    }
    .rightButton {
      position: absolute;
      right: 10px;
      top: 60px;
    }
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .row-box {
    display: flex;
    align-items: center;
    margin-top: 20px;
    .el-input {
      width: 30%;
      margin: 0 10px;
    }
  }
  .clear {
    clear: initial !important;
  }
  .pageNum {
    position: relative;
    bottom: 50px;
  }
  .rules {
    text-align: center;
    margin: 20px 0;
    font-size: 20px;
  }
  ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: white;
  }
  </style>